import React from 'react';
import './upcoming.css';
import b from '../images/bg1.jpg';
import b1 from '../images/bg2.jpg';
import b2 from '../images/bg3.jpeg';

const Upcoming = () => {
    return (
        <div className='upcoming'>

            <div className="major">
                <h1 className='head'>Upcoming</h1>
                <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="true">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src={b} class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                            <img src={b1} class="d-block w-100" alt="..."/>
                        </div>
                        <div class="carousel-item">
                            <img src={b2} class="d-block w-100" alt="..."/>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>


            </div>



        </div>

    );
}

export default Upcoming;
